import React from "react";
import styled from "styled-components";

// Pagination indicator for the image carousels: one dot per image, the current
// one highlighted. Sits centered near the bottom, just above the close/zoom
// buttons (which are at bottom:27px). Non-interactive so it never eats a swipe.
const Dots = styled.div`
  position: absolute;
  z-index: 10000;
  left: 50%;
  bottom: 120px;
  transform: translateX(-50%);
  display: flex;
  gap: 9px;
  pointer-events: none;
`;

const Dot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.45);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.55);
  transition: transform 0.25s ease, background 0.25s ease;

  &.active {
    background: #ffffff;
    transform: scale(1.35);
  }
`;

export default function CarouselDots({ count, current }) {
  if (!count || count < 2) return null; // no indicator for a single image
  const active = Math.min(Math.max(current || 0, 0), count - 1);
  return (
    <Dots>
      {Array.from({ length: count }).map((_, i) => (
        <Dot key={i} className={i === active ? "active" : ""} />
      ))}
    </Dots>
  );
}
